
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehicle-sales/[city]",
      function () {
        return require("private-next-pages/vehicle-sales/[city]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vehicle-sales/[city]"])
      });
    }
  